import { render, staticRenderFns } from "./bradesco.vue?vue&type=template&id=f68c4a0a&"
import script from "./bradesco.vue?vue&type=script&lang=js&"
export * from "./bradesco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports